import { useState } from 'react';
import Modal from 'react-modal';
import { toast } from 'react-toastify';
import { maskCpfCnpj, unMask } from '../../../../utils/masks';
import MaskedInput from 'react-text-mask';
import { API_URL } from '../../../../services/api';
import { Images } from '../../../../utils/images';
import { Container, Result } from './styles';
import { ModalHeader } from '../../../shared/ModalHeader';

export function SearchCadsUserModal({ isOpen, onRequestClose }) {
  const [cpfCnpj, setCpfCnpj] = useState('');
  const [cads, setCads] = useState('');
  const [requestSuccess, setRequestSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSearchCadsUser = async (e) => {
    e.preventDefault();
    setLoading(true);

    const body = {
      cpfCnpj: unMask(cpfCnpj),
    };

    const res = await fetch(`${API_URL}/pdvs/user-balance-inquiry`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: sessionStorage.getItem('token'),
      },
      body: JSON.stringify(body),
    });

    const response = await res.json();

    if (!res.ok) {
      toast.error(response.message);
    } else {
      toast.success(response.message);
      setCads(response?.data?.userCads);
      setRequestSuccess(response.message);
    }
    setLoading(false);
  };

  const closeModal = () => {
    setCpfCnpj('')
    setRequestSuccess('')
    onRequestClose()
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      overlayClassName="react-modal-overlay"
      className="react-modal-content"
    >
      <ModalHeader title='Consultar Saldo Usuário' handleClose={closeModal} />
      {
        requestSuccess !== '' ? (
          <Result className="animeLeft">
            <p>
              O usuário <span>{cpfCnpj}</span> possui <span>{cads}</span> cartões.
            </p>
            <img 
              src={Images.successImg} 
              alt="Sucesso" 
              onClick={closeModal} />
          </Result>
        ) : (
          <Container onSubmit={handleSearchCadsUser}>
            <MaskedInput
              mask={maskCpfCnpj}
              placeholder="Cpf ou Cnpj"
              guide={false}
              type="text"
              value={cpfCnpj}
              onChange={(event) => setCpfCnpj(event.target.value)}
              required
            />

            {loading ? (
              <button type="submit" disabled>
                Consultando...
              </button>
            ) : (
              <button type="submit">Consultar</button>
            )}
          </Container>
        )
      }
    </Modal>
  );
}
